import {Component} from '@angular/core';
import {DashboardService} from "../../shared/services/dashboard.service";
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {

    carouselOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      '<i class="icon-pagination-back font-16 text-black"></i>',
      '<i class="icon-pagination-forward font-16 text-black"></i>'
    ],
    margin: 10,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }

  constructor(private dashboardService: DashboardService) {
  }

  ngOnInit(): void {
    this.loadDashboard();
  }

  dashboardTilesData: any;

  loadDashboard() {
    this.dashboardService.getDashboardTiles().subscribe((response) => {
      this.dashboardTilesData = response.data;
    });
  }


}


